module.exports = __webpack_public_path__ + "img/anydesk.86ddb312.png";